import { cadastro_constante_aluno_novo } from "./cadastro-constante-aluno-novo";
import { cadastro_de_ensino_sem_retencao } from "./cadastro-de-ensino-sem-retencao";
import { cadastro_de_regra_para_valor_absoluto } from "./cadastro-de-regra-para-valor-absoluto";
import { cadastro_ensino_ministrado } from "./cadastro-ensino-ministrado";
import { cadastro_escola_contraturno } from "./cadastro-escola-contraturno";
import { confirmacao_turmas_mediacao_tecnologica } from "./confirmacao-turmas-mediacao-tecnologica";
import { copia_ensino_ministrado } from "./copia-ensino-ministrado";

const tabelas_apoio = [
  cadastro_de_regra_para_valor_absoluto,
  cadastro_ensino_ministrado,
  confirmacao_turmas_mediacao_tecnologica,
  cadastro_de_ensino_sem_retencao,
  copia_ensino_ministrado,
  cadastro_escola_contraturno,
  cadastro_constante_aluno_novo,
];

export { tabelas_apoio };
